import {
	Checkbox as CheckboxInput,
	type CheckboxProps,
} from 'components/InputUi';

import InputInfo from './InputInfo';

export interface Props extends CheckboxProps {
	errorMessage?: string | string[];
	helpText?: string;
}

export default function Checkbox({
	className,
	errorMessage,
	helpText,
	id,
	invalid,
	...checkboxAttrs
}: Props) {
	const errorMessageId = `${id}-error`;
	const helpTextId = `${id}-help`;

	return (
		<div className={className}>
			<CheckboxInput
				{...checkboxAttrs}
				id={id}
				invalid={invalid}
				aria-describedby={[errorMessageId, helpTextId].join(' ')}
				// Support for aria-errormessage isn't good enough as of autumn 2024
				// so stick with aria-describedby for now.
				// aria-errormessage={errorMessageId}
			/>
			<InputInfo
				invalid={invalid}
				errorMessage={errorMessage}
				errorMessageId={errorMessageId}
				helpText={helpText}
				helpTextId={helpTextId}
				className="ml-8 md:ml-7"
			/>
		</div>
	);
}
Checkbox.displayName = 'FormUI_Checkbox';
